export const SUB_ACCOUNT_REG_EXP = /.{1,42}[.|#].{1,42}.bit$/
